/**
 * Cobertura técnica do dia — domínio puro (GUPM-199).
 * ---------------------------------------------------
 * Fiel ao `buildTechCoverageWidget` do protótipo V8: em horário administrativo a
 * cobertura está "ativa" (RT Foscentro no plantão); fora dele, "sobreaviso" (RT
 * JF Brasil de sobreaviso). Não hardcoda PII — recebe os contatos que a UI puxa
 * do banco (`contacts`) e devolve os RTs da cadeia técnica.
 */
import { isBusinessHours } from './horario';

export type CoberturaEstado = 'ativa' | 'sobreaviso';

export interface CoberturaTecnica<T> {
  /** 'ativa' em horário administrativo; 'sobreaviso' fora dele. */
  estado: CoberturaEstado;
  ativa: boolean;
  /** RTs da cadeia técnica (cargo começa com "RT"): Foscentro + JF Brasil. */
  rts: T[];
}

/** Uma função de "RT" — começa com "RT " (RT Foscentro, RT JF Brasil). */
function funcaoDeRt(funcao: string): boolean {
  return funcao.trimStart().toUpperCase().startsWith('RT ');
}

/**
 * O contato é um RT da cadeia? GUPM-202 (D-16): olha CADA função — um contato
 * "Coordenador PAEBM" + "RT Foscentro" é RT. Sem `funcoes`, vale o `role`.
 */
function isRt(contato: { role: string; funcoes?: readonly string[] }): boolean {
  return (contato.funcoes ?? [contato.role]).some(funcaoDeRt);
}

/**
 * Estado da cobertura técnica + os RTs responsáveis, para o widget/modal do
 * dashboard. Puro e testável sem mock: recebe os contatos (que a UI puxa do banco)
 * e o instante de referência. Filtra os RTs pelas funções — se o banco cadastrar mais
 * RTs, todos aparecem (correto); PAEBM/Def. Civil ficam de fora do card de cobertura.
 */
export function coberturaTecnica<T extends { role: string; funcoes?: readonly string[] }>(
  contatos: T[],
  agora: Date = new Date(),
): CoberturaTecnica<T> {
  const ativa = isBusinessHours(agora);
  return {
    estado: ativa ? 'ativa' : 'sobreaviso',
    ativa,
    rts: contatos.filter(isRt),
  };
}
